<template>
  <div class="form-group row">
    <div class="col-12 row justify-content-md-center">
      <hr class="col-10">
    </div>

    <div class="col-md-2 col-sm-4 text-right">
      <label>Nome:</label>
    </div>
    <div class="col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.interessados.nome']">
    </div>
    <div class="col-md-2 col-sm-4 text-right">
      <label>Email:</label>
    </div>
    <div class="col-md-4 col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.interessados.contato']">
    </div>
    <div class="col-md-2 col-sm-4 text-right">
      <label>MATRICULA/CPF/CNPJ:</label>
    </div>
    <div class="col-md-4 col-sm-10 mb-3">
      <input id="identificador" type="text" class="form-control" v-model="filtro['atributos.interessados.identificador']">
    </div>

    <div class="col-12 row justify-content-md-center">
      <hr class="col-10">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    progressName: { required: true, type: String }
  },

  computed: mapState({
    filtro: state => state.filtroGeral,
    progress: state => state.progressFiltroGeral,
    progressInteressado () {
      var count = 0
      var max = 3
      count += this.filtro['atributos.interessados.titulo'] && this.filtro['atributos.interessados.titulo'] !== '' ? 1 : 0
      count += this.filtro['atributos.interessados.contato'] && this.filtro['atributos.interessados.contato'] !== '' ? 1 : 0
      count += this.filtro['atributos.interessados.identificador'] && this.filtro['atributos.interessados.identificador'] !== '' ? 1 : 0

      return (count / max) * 100
    }
  }),

  watch: {
    progressInteressado (newValue) {
      this.progress[this.progressName] = newValue.toFixed()
      this.progress.change = !this.progress.change
    }
  }
}
</script>
